import { Provider } from '@angular/core';

import { CODES_REPOSITORY } from '@/domain/repositories/codes/codes.repository.contract';
import { CodesRepositoryImpl } from '@/repositories/codes/codes.repository';

export const codesRepositoryProvider: Provider = {
  provide: CODES_REPOSITORY,
  useClass: CodesRepositoryImpl
};
